import React from 'react'

import { ReactNode } from 'react'
import { UnitPrefix } from 'types/GlobalKpiOption'
import { TFunction } from 'language/translator'
import { getUnitLabel } from 'utils/unitLabel'

export type TEquivalent = {
  factor: number | null
  unit: string | null
}

export const getUnitPrefixOptions = (
  unit: string | null,
  unitPrefix: {
    selected: UnitPrefix | null
    options: { value: UnitPrefix; label: string }[]
  },
  t: TFunction
) => {
  const newOptions = unitPrefix.options.map((option) => {
    return {
      title: getUnitLabel(unit, {
        selected: option.value,
        options: unitPrefix.options
      }),
      id: option.value
    }
  })

  const defaultOptions =
    unit === '%'
      ? []
      : [
          {
            title: unit ?? t('global', 'none'),
            id: ''
          }
        ]

  return [...defaultOptions, ...newOptions]
}

export const getHelpText = (
  unitLabel: string,
  equivalent: TEquivalent,
  t: TFunction
): ReactNode | null => {
  let previewText = ''

  const currentUnit = `${unitLabel ? ' ' : ''}${unitLabel}`
  const newUnit = `${equivalent.unit ? ' ' : ''}${equivalent.unit}`

  if (equivalent.factor && equivalent.unit) {
    previewText = t('widgets', 'equivalent_preview_both', false, {
      current: currentUnit,
      factor: String(equivalent.factor),
      new: newUnit
    })
  } else if (equivalent.factor && !equivalent.unit) {
    previewText = t('widgets', 'equivalent_preview_factor_only', false, {
      current: currentUnit,
      factor: String(equivalent.factor)
    })
  } else if (!equivalent.factor && equivalent.unit) {
    previewText = t('widgets', 'equivalent_preview_unit_only', false, {
      current: currentUnit,
      new: newUnit
    })
  }

  return (
    <>
      {t('widgets', 'equivalent_helper_intro')}
      {previewText ? (
        <>
          <br />
          <b>{previewText}</b>
        </>
      ) : null}
    </>
  )
}

export const getPreviewValue = (
  unitLabel: string,
  equivalent: TEquivalent
): string | null => {
  const currentUnit = `${unitLabel ? ' ' : ''}${unitLabel}`
  const newUnit = `${equivalent.unit ? ' ' : ''}${equivalent.unit}`

  if (equivalent.factor && equivalent.unit) {
    return `1${currentUnit} = ${equivalent.factor}${newUnit}`
  } else if (equivalent.factor && !equivalent.unit) {
    return `1${currentUnit} = ${equivalent.factor}${currentUnit}`
  } else if (!equivalent.factor && equivalent.unit) {
    return `1${currentUnit} = 1${newUnit}`
  } else {
    return null
  }
}
